import React from 'react';
import { CommunicationIllustrationProps } from '../CommunicationMessage';

export const WAITING_ILLUSTRATIONS: CommunicationIllustrationProps = {
  LIGHT: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 892.6139 540.80203"
    >
      <circle cx="459.05561" cy="314.39327" r="210.50358" fill="#3f3d56" />
      <circle cx="459.05561" cy="314.39327" r="193.07779" fill="#fff" />
      <circle cx="458.35857" cy="315.0903" r="25.79017" fill="#3f3d56" />
      <rect
        x="452.78232"
        y="131.07392"
        width="11.15251"
        height="20.91095"
        fill="#3f3d56"
      />
      <rect
        x="452.78232"
        y="478.19572"
        width="11.15251"
        height="20.91095"
        fill="#3f3d56"
      />
      <rect
        x="432.91447"
        y="484.23381"
        width="11.15251"
        height="20.91095"
        transform="translate(779.48696 -123.40042) rotate(90)"
        fill="#3f3d56"
      />
      <rect
        x="780.03627"
        y="484.23381"
        width="11.15251"
        height="20.91095"
        transform="translate(1126.60876 -470.52223) rotate(90)"
        fill="#3f3d56"
      />
      <polygon
        points="450.924 326.286 460.455 304.493 579.88 370.635 450.924 326.286"
        fill="#3f3d56"
      />
      <rect
        x="431.87137"
        y="53.00636"
        width="54.36848"
        height="62.73286"
        fill="#3f3d56"
      />
      <ellipse
        cx="459.05561"
        cy="53.00636"
        rx="62.73286"
        ry="17.42579"
        fill="#3f3d56"
      />
      <path
        d="M730.1985,531.28345l-3.48516,4.87922s-16.03173,18.81986-16.72876,9.75845,11.84954-15.3347,11.84954-15.3347l6.97032-4.18219Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M829.41778,547.74522l2.91833,5.238s10.14843,22.54357,1.66044,19.29564-8.78836-17.27221-8.78836-17.27221l-.79685-8.08957Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <circle cx="660.03348" cy="254.04245" r="21.22425" fill="#2f2e41" />
      <path
        d="M811.75122,607.95694l2.78812,18.12283V631.656h16.03173V624.6857s.697-12.54657-2.09109-16.03173S811.75122,607.95694,811.75122,607.95694Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M783.17291,607.95694l2.78813,18.12283V631.656h16.03173V624.6857s.697-12.54657-2.09109-16.03173S783.17291,607.95694,783.17291,607.95694Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M793.96129,462.38371s-6.16626,3.25-1.9546,10.64285,28.92249,83.8766,28.92249,83.8766l14.25582-4.04685-12.57235-48.37053-7.1988-30.40158Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#d60b51"
      />
      <circle cx="657.70965" cy="260.02479" r="16.03173" fill="#ffb8b8" />
      <path
        d="M818.72153,442.06339l-2.09109,32.76049L801.99277,464.3684s4.87922-19.51689,3.48516-20.911Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M818.72153,472.03575l-15.769-11.67706s-7.23305-2.9606-9.32415.52455-12.54657,55.06551-6.97032,64.824c0,0,29.97237,6.27328,36.24565,2.78812l2.78813-18.12282s3.48516-11.15251-2.0911-18.12283Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#d60b51"
      />
      <path
        d="M797.81058,461.58028s-5.57625-4.18219-10.45548,2.78812-63.42988,62.03583-63.42988,62.03583l9.75844,11.15251,38.33675-32.06346,24.39611-19.51689Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#d60b51"
      />
      <path
        d="M823.25224,528.14681s-34.50307-6.6218-37.98823-1.74258l-.697,7.66735s-7.66735,14.63766-3.48516,38.33674,1.39406,38.33675,1.39406,38.33675,18.81986-2.0911,32.76049,0,16.03173,0,16.03173,0Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#2f2e41"
      />
      <path
        d="M831.96514,628.86789l-20.21392.697,6.97031,52.27739s-5.57625,22.305.697,23.69907a70.7125,70.7125,0,0,0,13.24361,1.39407s6.27328,6.27328,13.2436,5.57625a39.034,39.034,0,0,0,13.2436-4.18219s1.39407-4.18219-3.48516-5.57625-18.12282-5.57626-20.911-20.21392Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#2f2e41"
      />
      <path
        d="M803.38683,628.86789l-20.21392.697,6.97032,52.27739s-5.57625,22.305.697,23.69907a70.7125,70.7125,0,0,0,13.24361,1.39407s6.27328,6.27328,13.2436,5.57625a39.034,39.034,0,0,0,13.2436-4.18219s1.39407-4.18219-3.48516-5.57625S808.96309,697.177,806.175,682.53934Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#2f2e41"
      />
      <circle cx="667.45803" cy="231.7041" r="8.78245" fill="#2f2e41" />
      <path
        d="M832.861,406.54593a8.78336,8.78336,0,0,0-7.86761-8.735,8.881,8.881,0,0,1,.91484-.04748,8.78244,8.78244,0,0,1,0,17.56489,8.881,8.881,0,0,1-.91484-.04748A8.78336,8.78336,0,0,0,832.861,406.54593Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#2f2e41"
      />
      <ellipse
        cx="657.56451"
        cy="249.54235"
        rx="14.63741"
        ry="8.78245"
        fill="#2f2e41"
      />
    </svg>
  ),
  DARK: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 892.6139 540.80203"
    >
      <circle cx="459.05561" cy="314.39327" r="210.50358" fill="#737373" />
      <circle cx="459.05561" cy="314.39327" r="193.07779" fill="#e3e3e3" />
      <circle cx="458.35857" cy="315.0903" r="25.79017" fill="#737373" />
      <rect
        x="452.78232"
        y="131.07392"
        width="11.15251"
        height="20.91095"
        fill="#737373"
      />
      <rect
        x="452.78232"
        y="478.19572"
        width="11.15251"
        height="20.91095"
        fill="#737373"
      />
      <rect
        x="432.91447"
        y="484.23381"
        width="11.15251"
        height="20.91095"
        transform="translate(779.48696 -123.40042) rotate(90)"
        fill="#737373"
      />
      <rect
        x="780.03627"
        y="484.23381"
        width="11.15251"
        height="20.91095"
        transform="translate(1126.60876 -470.52223) rotate(90)"
        fill="#737373"
      />
      <polygon
        points="450.924 326.286 460.455 304.493 579.88 370.635 450.924 326.286"
        fill="#737373"
      />
      <rect
        x="431.87137"
        y="53.00636"
        width="54.36848"
        height="62.73286"
        fill="#737373"
      />
      <ellipse
        cx="459.05561"
        cy="53.00636"
        rx="62.73286"
        ry="17.42579"
        fill="#737373"
      />
      <path
        d="M730.1985,531.28345l-3.48516,4.87922s-16.03173,18.81986-16.72876,9.75845,11.84954-15.3347,11.84954-15.3347l6.97032-4.18219Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M829.41778,547.74522l2.91833,5.238s10.14843,22.54357,1.66044,19.29564-8.78836-17.27221-8.78836-17.27221l-.79685-8.08957Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <circle cx="660.03348" cy="254.04245" r="21.22425" fill="#5b5980" />
      <path
        d="M811.75122,607.95694l2.78812,18.12283V631.656h16.03173V624.6857s.697-12.54657-2.09109-16.03173S811.75122,607.95694,811.75122,607.95694Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M783.17291,607.95694l2.78813,18.12283V631.656h16.03173V624.6857s.697-12.54657-2.09109-16.03173S783.17291,607.95694,783.17291,607.95694Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M793.96129,462.38371s-6.16626,3.25-1.9546,10.64285,28.92249,83.8766,28.92249,83.8766l14.25582-4.04685-12.57235-48.37053-7.1988-30.40158Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#d60b51"
      />
      <circle cx="657.70965" cy="260.02479" r="16.03173" fill="#ffb8b8" />
      <path
        d="M818.72153,442.06339l-2.09109,32.76049L801.99277,464.3684s4.87922-19.51689,3.48516-20.911Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#ffb8b8"
      />
      <path
        d="M818.72153,472.03575l-15.769-11.67706s-7.23305-2.9606-9.32415.52455-12.54657,55.06551-6.97032,64.824c0,0,29.97237,6.27328,36.24565,2.78812l2.78813-18.12282s3.48516-11.15251-2.0911-18.12283Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#d60b51"
      />
      <path
        d="M797.81058,461.58028s-5.57625-4.18219-10.45548,2.78812-63.42988,62.03583-63.42988,62.03583l9.75844,11.15251,38.33675-32.06346,24.39611-19.51689Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#d60b51"
      />
      <path
        d="M823.25224,528.14681s-34.50307-6.6218-37.98823-1.74258l-.697,7.66735s-7.66735,14.63766-3.48516,38.33674,1.39406,38.33675,1.39406,38.33675,18.81986-2.0911,32.76049,0,16.03173,0,16.03173,0Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#5b5980"
      />
      <path
        d="M831.96514,628.86789l-20.21392.697,6.97031,52.27739s-5.57625,22.305.697,23.69907a70.7125,70.7125,0,0,0,13.24361,1.39407s6.27328,6.27328,13.2436,5.57625a39.034,39.034,0,0,0,13.2436-4.18219s1.39407-4.18219-3.48516-5.57625-18.12282-5.57626-20.911-20.21392Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#5b5980"
      />
      <path
        d="M803.38683,628.86789l-20.21392.697,6.97032,52.27739s-5.57625,22.305.697,23.69907a70.7125,70.7125,0,0,0,13.24361,1.39407s6.27328,6.27328,13.2436,5.57625a39.034,39.034,0,0,0,13.2436-4.18219s1.39407-4.18219-3.48516-5.57625S808.96309,697.177,806.175,682.53934Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#5b5980"
      />
      <circle cx="667.45803" cy="231.7041" r="8.78245" fill="#5b5980" />
      <path
        d="M832.861,406.54593a8.78336,8.78336,0,0,0-7.86761-8.735,8.881,8.881,0,0,1,.91484-.04748,8.78244,8.78244,0,0,1,0,17.56489,8.881,8.881,0,0,1-.91484-.04748A8.78336,8.78336,0,0,0,832.861,406.54593Z"
        transform="translate(-153.69305 -179.59899)"
        fill="#5b5980"
      />
      <ellipse
        cx="657.56451"
        cy="249.54235"
        rx="14.63741"
        ry="8.78245"
        fill="#5b5980"
      />
    </svg>
  ),
};
